import * as React from "react";

const SvgIcnWhatsappBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M20 11.794c0 4.304-3.516 7.794-7.855 7.794a7.868 7.868 0 01-3.796-.97L4 20l1.418-4.182a7.712 7.712 0 01-1.127-4.024C4.29 7.489 7.807 4 12.145 4 16.485 4 20 7.49 20 11.794zm-3.888 1.795c-.049-.08-.177-.127-.37-.223-.192-.095-1.139-.558-1.315-.621-.176-.064-.305-.096-.433.095s-.497.622-.61.749c-.112.128-.225.144-.417.048-.193-.095-.813-.297-1.548-.948a5.76 5.76 0 01-1.071-1.323c-.113-.19-.012-.294.084-.39.087-.085.193-.222.289-.334.096-.112.128-.191.192-.319.065-.127.033-.239-.016-.334-.048-.096-.433-1.036-.594-1.419-.16-.382-.53-.346-.659-.346-.128 0-.48.06-.656.25-.177.192-.674.654-.674 1.594 0 .94.69 1.849.786 1.976.096.127 1.44 2.24 3.29 2.884 1.849.644 2.037.53 2.31.478.272-.052 1.004-.37 1.232-.83.228-.46.228-.907.18-.987z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnWhatsappBold;
